import fetch from 'app/utils/requests/fetch';
import type { TokenPayload } from 'app/services/auth';
import {
  ONE_FIIT_ID_TOKEN_SUBJECT_TOKEN_TYPE,
  ONE_FIIT_TOKEN_EXCHANGE_GRANT_TYPE,
  type OneFiitTokenResponse,
  parseOneFiitTokenResponse,
} from 'app/services/one-fiit';
import urlQueryParams from 'app/utils/requests/query-params';

type CreateCognitoServiceArgs = {
  url: string;
  oneFiitAuthUrl?: string;
  clientId?: string;
};

const createCognitoService = ({ url, oneFiitAuthUrl, clientId }: CreateCognitoServiceArgs) => {
  if (!url && !oneFiitAuthUrl) {
    throw new Error('No URL to Cognito API service supplied');
  }

  if (oneFiitAuthUrl && !clientId) {
    throw new Error('No client id for the one-fiit auth service supplied');
  }

  const exchangeCognitoToken = async (token: string): Promise<TokenPayload> => {
    if (oneFiitAuthUrl) {
      const params = urlQueryParams({
        grant_type: ONE_FIIT_TOKEN_EXCHANGE_GRANT_TYPE,
        client_id: clientId,
        subject_token: token,
        subject_token_type: ONE_FIIT_ID_TOKEN_SUBJECT_TOKEN_TYPE,
      });

      const { body } = await fetch(oneFiitAuthUrl, {
        body: params,
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
      });

      return parseOneFiitTokenResponse(body as OneFiitTokenResponse);
    }

    const params = urlQueryParams({
      token,
    });

    const { body } = await fetch(url, {
      body: params,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
    });

    return body as TokenPayload;
  };

  return {
    exchangeCognitoToken,
  };
};

export type CognitoService = ReturnType<typeof createCognitoService>;

export default createCognitoService;
